import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

export interface CreateAuthorizationRequestForTreatmentPayload {
  procedure_code: string;
}

interface CreateAuthorizationRequestForTreatmentParams {
  data: CreateAuthorizationRequestForTreatmentPayload;
  treatmentId: string;
}

const createAuthorizationRequestForTreatment = async ({ treatmentId, data }: CreateAuthorizationRequestForTreatmentParams) => {
  const endpoint = apiEndpoints.PATIENTS_VALIDATE_TREATMENT(treatmentId)
  const result = await axios.post(endpoint, data)
  return result
}

export {
  createAuthorizationRequestForTreatment
}

